import {BaseCachedService} from './Core/BaseCachedService';
import {BaseService} from "./Core/BaseService";

class PhotoService extends BaseCachedService {
    get Url() { return super.Url + "/photos"; }

    UpdatePhoto(photo) {
        return this.SendRequest(BaseService.PUT, photo);
    }
}

export const service = new PhotoService();

